import React from 'react';
import { walkClaimText } from '../../../../lib/walkClaimText';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

export const GroundwaterSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const ground = report.waterAnalysis?.groundwaterAssessment;
  const surface = report.waterAnalysis?.surfaceWaterAssessment;
  const hasData = !!(ground || surface);
  return (
    <SectionShell label={label} hasData={hasData}>
      {ground && (
        <EditorialSubsection theme={theme} label="Groundwater">
          {walkClaimText(ground, report.references)}
        </EditorialSubsection>
      )}
      {surface && (
        <EditorialSubsection theme={theme} label="Surface water">
          {walkClaimText(surface, report.references)}
        </EditorialSubsection>
      )}
    </SectionShell>
  );
};
